import { React, useEffect, useState, useContext } from 'react'
import axios from "axios";
import { GlobalLoading, showLoading } from 'react-global-loading';
import { MyContextProvider } from '../../../../App';
import { API_URL } from '../../../../Constant';
import { perVariationRuralAndUrbanwageIndex } from '../../../../Custom/PriceWagesIndiceSystemReport/ExportExcel';
import { changeDateFormat } from "../../../../Custom/Custom";
import { useNavigate } from "react-router-dom";
import titlesData from '../../../../titles.json';
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../../../assets/Messages.json';

function Report_PercentageVariationSheetofUrbanWageindex() {

  const [years, setYears] = useState([]);
  const [yearName, setyearName] = useState('');
  const [months, setMonth] = useState(
    [{ value: "1", label: "APR-JUN" },
    { value: "2", label: "JUL-SEP" },
    { value: "3", label: "OCT-DEC" },
    { value: "4", label: "JAN-MAR" }]);
  const [monthName, setMonthName] = useState('');
  const token = useContext(MyContextProvider).token;
  const navigate = useNavigate();
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  //Get all Years Data
  useEffect(() => { 
    //Years
  const fetchYears = async () => {
      const currentYear = new Date().getFullYear();
      const endYear = 2001;
      const yearsArray = [];
    for (let year = currentYear; year >= endYear; year--) {
        yearsArray.push(`${year}-${year + 1}`);
      }

      setYears(yearsArray);

    };
    fetchYears();
 }, []);



  const getQuarterLabel = (monthValue) => {
    const quarters = {
      "1": "Apr-Jun",
      "2": "Jul-Sep",
      "3": "Oct-Dec",
      "4": "Jan-Mar"
    };
    return quarters[monthValue] || '';
  };


  const formatGrossValue = (value) => {
    if (value === 0) return '0.0';
    if (value === "NaN" ) return '';
    if (value === '' || value === null || value === 'null') return '0.0';
    return Number(value).toFixed(2);
    };


  //handle excel sheet ***************
  const handleGenerateExcel = () => {

   showLoading(true);
    let postData = {
      "year": yearName,
      "quarter": monthName,

    }

    // POST request to API
    axios
      .post(`${API_URL}api/price/PerVariationUrbanWageIndex`, postData, config)
      .then((response) => {
      let reportData=response.data;

     if(reportData.status){

   // Handle success and generate the Excel file directly
        const ruralWageIndexDataResponse =reportData.data.GroupCodes;
        const quarterLabel = getQuarterLabel(monthName);
        let excelFileName = `PriLwsUrbanWagesVariationIndexe_Q${monthName}_${yearName.split("-")[0]}`;
        const excelObjectData = {
          fileName: excelFileName,
          reportType: "Pri_Urban",
          fileType: 'xls',
          sheetName: "Pri_Urban",
          firstRowMergeCells: "A1:G1",
          firstRowExportDate: changeDateFormat(new Date()),
          firstRowCellNumber: 7,
          secondRowMergeCells: "A2:G2",
          secondRowText: 'Table=Percentage Variation Sheetof Urban Wage Index (Base Year 2011-12=100)',
          secondRowCellNumber: 7,
          thirdRowMergeCells: "A3:G3",
          thirdRowText: `Month ${quarterLabel}, ${yearName}`,
          headerEnglishColumns: [
            'ITEM/REGION', 'QUARTER', 'WESTERN', 'CENTRAL', 'B.KHAND', 'EASTERN', 'STATE'
          ],

        };

        const transformedData = ruralWageIndexDataResponse.map((item, index) => [
          item.quarter === "I.P.Q" ? '' : item.itemName,
          item.quarter,
          formatGrossValue(item.westernregion),
          formatGrossValue(item.centralregion),
          formatGrossValue(item.bkhandregion),
          formatGrossValue(item.easternregion),
          formatGrossValue(item.stateregion)
        ]);


        excelObjectData.excelRowData = transformedData;
        perVariationRuralAndUrbanwageIndex(excelObjectData);
        showLoading(false);
      }else{
        toast.error('Data is not found', messages.COLOR_RED);
      }
      }).catch((error) => {
        // Handle error if needed
        console.error('API Error:', error);
       }).finally(()=>{
        showLoading(false);
      });
  };



  const storedLanguage = localStorage.getItem('language');


  return (
    <>

    <ToastContainer />
    <GlobalLoading />

    <div className="container-fluid py-3">
      <div className="card mx-3 mb-3">
        <div className="card-body pb-1">
          <div className="row align-items-center">
            <h4 className="page_heading"><span className="text_orange"> {storedLanguage === 'hi' ? titlesData.hi.PriceWagesIndicesSystem : titlesData.en.PriceWagesIndicesSystem}</span> (Labour Wages - Urban Variation Index)</h4>


            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
              <label>Select Year</label>
              <select 
               value={yearName} 
               onChange={(e) => (setyearName(e.target.value))} 
               name="year_name" 
               className="form-select" 
              >
                <option value="" disabled >Select Year</option>
                {years.map((ele, index) => (
                  <option key={index} value={ele}>
                    {ele}
                  </option>
                ))}

              </select>
            </div>


            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-6 mb-3">
              <label>Select Quarter</label>
                 <select 
                  value={monthName} 
                  onChange={(e) => (setMonthName(e.target.value))} 
                  name="month_name" 
                  className="form-select"
                 >
                <option value="" disabled>Select Quarter</option>
                {months.map((quarter, i) => (
                  <option key={i} value={quarter.value}>
                    {quarter.label}
                  </option>
                ))}

              </select>

            </div>



            <div className="col-xl-2 col-lg-4 col-md-4 col-sm-4 col-12 mb-3">
              <label className="w-100 d-none d-sm-block">&nbsp;</label>
              <button 
               onClick={handleGenerateExcel} 
               type="submit" 
               className="btn btn_orange"
              >
              Get Data
            </button>
            </div>
          </div>
        </div>
      </div>

    </div>

  </>
  )
}

export default Report_PercentageVariationSheetofUrbanWageindex